import React from 'react';
import tw from 'twin.macro';

import AppGalleryIcon from '@/assets/images/icons/AppGalleryIcon';
import AppStoreIcon from '@/assets/images/icons/AppStoreIcon';
import GooglePlayIcon from '@/assets/images/icons/GooglePlayIcon';
import { BodyText, StepContentWrapper, Title } from '@/components';

const ExistDepositCardPage = () => {
  return (
    <StepContentWrapper twStyles={tw`text-center max-w-content mx-auto`}>
      <Title text='У вас уже есть DEPOSIT CARD' variant='bold' twStyle={tw`mt-[24px] mb-[24px]`} />
      <BodyText
        text={
          <span>
            Скачайте приложение «Freedom Bank»
            <br /> и управляйте своими счетами
          </span>
        }
        twStyle={tw`text-secondary text-center`}
      />
      <div tw='flex flex-col sm:flex-row gap-3 justify-center my-3'>
        <AppButton>
          <AppStoreIcon />
        </AppButton>
        <AppButton>
          <GooglePlayIcon />
        </AppButton>
        <AppButton>
          <AppGalleryIcon />
        </AppButton>
      </div>
    </StepContentWrapper>
  );
};

export default ExistDepositCardPage;

const AppButton = ({ children, ...props }) => {
  return (
    <a tw='h-[48px] rounded-[8px] bg-black flex items-center justify-center px-3' {...props}>
      {children}
    </a>
  );
};
